import { render } from "./VeeRadio.vue?vue&type=template&id=01d8993d"
import script from "./VeeRadio.vue?vue&type=script&lang=js"
export * from "./VeeRadio.vue?vue&type=script&lang=js"

import exportComponent from "/home/los4/mnt/OutHouse/los/Documents/htdocs/LosPrograms/Life/regLosers/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__